export const messages = {
  en: {
    chooseShopVipUser: {
      title: 'Select Member Information',
      vipName: 'Member Name',
      vipTel: 'Member Phone',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      entryTime: 'Entry Time',
      operation: 'Operation',
      select: 'Select',
      searchPlaceholder: 'Enter member name',
      searchBtn: 'Search'
    }
  },
  zh: {
    chooseShopVipUser: {
      title: '选择会员信息',
      vipName: '会员名称',
      vipTel: '会员电话',
      gender: '性别',
      male: '男',
      female: '女',
      entryTime: '入驻时间',
      operation: '操作',
      select: '选择',
      searchPlaceholder: '输入会员信息名称',
      searchBtn: '查询'
    }
  }
}